import React from 'react';
import moment from 'moment';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Circles } from "../../../components/common/loadingComponent";
import { writeErr } from '../../common/logger';
import { FileUpload } from "../../common/fileUpload";
import { withRouter } from 'react-router';
import { searchActions } from '../../../store/searchStore';
import { domainActions } from '../../../store/domainStore';
import { isGuid, isNullOrUndefined, isValidLanguage, validateInput } from '../../../store/storeFunctions';
import { getHostApi, apiPost, getHostUrl } from '../../../store/apiWrapper';
import { Popover, PopoverBody } from 'reactstrap';
import Paging from "../../../components/common/pagingComponent";
import Message from "../../common/message";
import ModalInner from '../../layoutItems/modalInner';
import BbCheckbox from "../../../components/styling/bbCheckbox";
import BbDatePicker from "../../common/datePicker";
import RelationLink from "../../reportSections/relations/relationLink";
import PropertySkOwnershipDeedSearchForm from '../../search/propertySk/searchForms/propertySkOwnershipDeedSearchForm';
import AngleDownIcon from '../../../img/icons/BBiconsRozbalit';
import generatedId from '../../common/newIdGenerator';
import NoDataComponent from '../../common/noDataComponent';
import { PORTFOLIO_TYPES } from '../monitoringConstants';

import "./searchSubjectPopup.scss";

const FROM_FILE = "FROM_FILE";
const FROM_SEARCH = "FROM_SEARCH";

const SEARCH_MODEL = {
    name: "",
    surname: "",
    label: "",
    companyId: "",
    personalId: "",
    birthDate: null
};

const CHECK_OPTIONS = {
    onlyInDb: "OnlyInDb",
    unmatched: "Unmatched",
    all: "All",
    none: "None"
}

const DEFAULT_STATE = {
    file: null,
    subjects: [],
    subjectsSource: null,
    notFoundSubjects: null,
    searchFinished: false,
    searchTerm: "",
    searchTermSurname: "",
    dob: null,
    pin: "",
    label: "",
    isLoading: false,
    totalCount: 0,
    isAddingSubjects: false,
    regionId: "",
    districtId: "",
    municipalityId: "",
    cadastreUnitId: "",
    documentMessage: null,
    errorMessage: null,
    excelError: null,
    addError: null,
    warningMessage: null,
    selected: [],
    deselected: [],
    showSelect: false,
    elementId: generatedId(),
    checkOption: CHECK_OPTIONS.none,
    excelSearchType: null
};

class SearchSubjectPopup extends React.Component {
    page = 1;
    pageSize = 20;
    state = { ...DEFAULT_STATE };
    _noConflictPopover2 = undefined;

    render() {
        return (
            <ModalInner title={this.props.translate(this.getPopupTitleTrKey())} close={() => this.props.close(true)}>
                <div className="portfolio-subjects-popup">
                    {this.state.addError && <Message type="error" options={{ renderInnerHtml: true }}
                        message={this.props.translate(this.state.addError.exception, this.state.addError.exceptionData)}
                    />}
                    {this.state.subjectsSource === null && this.renderChoices()}
                    {this.state.subjectsSource === FROM_SEARCH && this.renderChoiceFromSearch()}
                    {this.state.subjectsSource === FROM_FILE && this.renderChoiceFromFile()}
                </div>
            </ModalInner>
        )
    }

    renderChoices = () => {
        return (
            <div className="modal-inner-buttons">
                <button onClick={() => this.setState({ subjectsSource: FROM_SEARCH })}
                    className={classnames('bb-button gradient-1 search-button', { 'is-square': localStorage.locales_button_style === 'square' })}
                >
                    <Translate id="Portfolio.Find.In.Cribis" />
                </button>
                <button onClick={() => this.setState({ subjectsSource: FROM_FILE })}
                    className={classnames('bb-button gradient-1 search-button', { 'is-square': localStorage.locales_button_style === 'square' })}
                >
                    <Translate id="Marketing.Insert.File" />
                </button>
            </div>
        )
    }

    renderChoiceFromFile = () => {
        return (
            <>
                {this.state.excelError && <div className="columns">
                    <div className="column">
                        {this.state.excelSearchType === "person" ?
                            <Message type="error" message={this.props.translate(this.state.excelError.exception)} options={{ renderInnerHtml: true }}></Message>
                            :
                            <Message type="error" message={this.props.translate("Error.WrongFileProcessing")} options={{ renderInnerHtml: true }}>
                                <ul style={{ listStyleType: "disc" }}>
                                    <li style={{ marginLeft: "2em" }}>{this.props.translate(this.state.excelError.exception, this.state.excelError.exceptionData)}</li>
                                </ul>
                            </Message>}
                    </div>
                </div>}
                {this.state.warningMessage && <div className="portfolio-search-error">
                    <Message type="warning" options={{ renderInnerHtml: true }}
                        message={this.props.translate(this.state.warningMessage)}
                    />
                </div>}
                <FileUpload resetCallback={() => this.reset(FROM_FILE)} callback={(result) => { this.fileUploaded(result); this.setState({ subjectsSource: FROM_FILE }) }}>
                    <a href={this.getBulkTemplateUrl(this.getPortfolioType(), this.props.activeLanguage.code)} download
                        className="link-functional" style={{ display: "flex", justifyContent: "center", paddingTop: "1em" }}
                    >
                        <Translate id="Search.Common.BulkTemplate" />
                    </a>
                </FileUpload>
                {this.state.subjects.length === 0 && <div className="modal-inner-buttons portfolio-search-buttons">
                    <button className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.reset()}>
                        <Translate id="Common.Back" />
                    </button>
                </div>}
                {this.state.isLoading && <Circles position="static" />}
                {this.renderSearchResults()}
            </>
        )
    }

    renderChoiceFromSearch = () => {
        return (
            <div>
                {this.state.notFoundSubjects && this.getSubjectType() === "persons" && <div className="columns is-centered">
                    <Message type="error" message={this.props.translate('Report.Common.InvalidData')} />
                </div>}
                {this.state.isLoading ? <Circles position="static" /> : <>
                    {this.getSubjectType() === 'documents' ? this.renderDocumentSearch() : this.renderPortfolioQuickSearch()}
                    {this.renderSearchResults()}
                </>}
            </div>
        );
    }

    renderPortfolioQuickSearch = () => {
        const enabled = this.canSearch({ searchTerm: this.state.searchTerm, dob: this.state.dob, pin: this.state.pin, searchTermSurname: this.state.searchTermSurname });
        return (
            <>
                {this.state.errorMessage && <div className="portfolio-search-error">
                    <Message type="error" options={{ renderInnerHtml: true }}
                        message={this.props.translate(this.state.errorMessage.exception, this.state.errorMessage.exceptionData)}>
                        <ul style={{ listStyleType: "disc" }}>
                            {this.state.errorMessage.submessages && this.state.errorMessage.submessages.map(k => <li key={k} style={{ marginLeft: "3em" }}>{this.props.translate(k)}</li>)}
                        </ul>
                    </Message>
                </div>}
                {this.state.warningMessage && <div className="portfolio-search-error">
                    <Message type="warning" options={{ renderInnerHtml: true }}
                        message={this.props.translate(this.state.warningMessage)}
                    />
                </div>}
                <div className="portfolio-search-subject-form">
                    {this.getSubjectType() === "persons" && <div className="columns">
                        <div className="field bb-field">
                            <div className="control" data-error="false">
                                <div className="columns">
                                    <div className="column is-4">
                                        <Translate id="Portfolio.Pin" />
                                    </div>
                                    <div className="column is-8">
                                        <input onKeyDown={(e) => e.keyCode === 13 && this.submitQuickSearch(true)} type="text" className="input form-control" value={this.state.pin}
                                            onChange={(e) => this.setState({ pin: e.target.value, searchFinished: false })} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.getSubjectType() !== "documents" && <div className="columns">
                        <div className="field bb-field">
                            <div className="control" data-error="false">
                                <div className="columns">
                                    <div className="column is-4">
                                        {this.getSubjectType() === "companies" && <Translate id="Portfolio.Ico.Name" />}
                                        {this.getSubjectType() === "persons" && <Translate id="Portfolio.Name" />}
                                    </div>
                                    <div className="column is-8">
                                        <input onKeyDown={(e) => e.keyCode === 13 && this.submitQuickSearch(true)} type="text" className="input form-control"
                                            value={this.state.searchTerm} onChange={(e) => this.setState({ searchTerm: e.target.value, searchFinished: false })} onInput={(e) => validateInput(e)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.getSubjectType() === "persons" && <div className="columns">
                        <div className="field bb-field">
                            <div className="control" data-error="false">
                                <div className="columns">
                                    <div className="column is-4">
                                        <Translate id="Portfolio.Surname" />
                                    </div>
                                    <div className="column is-8">
                                        <input onKeyDown={(e) => e.keyCode === 13 && this.submitQuickSearch(true)} type="text" className="input form-control"
                                            value={this.state.searchTermSurname} onChange={(e) => this.setState({ searchTermSurname: e.target.value, searchFinished: false })} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.getSubjectType() === "persons" && <div className="columns">
                        <div className="field bb-field">
                            <div className="control" data-error="false">
                                <div className="columns">
                                    <div className="column is-4">
                                        <Translate id="Monitoring.Add.DOB" />
                                    </div>
                                    <div className="column is-8">
                                        <BbDatePicker
                                            afterDateChange={(day) => this.afterDateChange(day)}
                                            value={this.state.dob}
                                            style={{ width: '100%' }}
                                            name="dob"
                                            id="dob"
                                            formDateFormat="YYYY-MM-DD"
                                            yearsBack={120} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
                {(isNullOrUndefined(this.state.notFoundSubjects) && this.state.subjects.length === 0 && this.state.searchFinished) &&
                    <div className="columns is-centered no-data"><NoDataComponent /></div>}
                <div className="modal-inner-buttons portfolio-search-buttons">
                    {this.state.subjects.length === 0 && <button className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                        onClick={() => this.reset()}
                    >
                        <Translate id="Common.Back" />
                    </button>}
                    <button className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        onClick={() => this.submitQuickSearch(true)} disabled={!enabled}
                    >
                        <Translate id="Common.Search" />
                    </button>
                </div>
            </>
        )
    }

    afterDateChange = (day) => {
        var validatedDate = moment(day, ["D.M.YYYY", "DD.M.YYYY", "D.MM.YYYY", "DD.MM.YYYY"], true);
        this.setState({ dob: validatedDate.isValid() ? validatedDate.toDate() : undefined })
    }

    renderSearchResults = () => {
        if (isNullOrUndefined(this.state.notFoundSubjects) && this.state.subjects.length === 0)
            return null;

        return (
            <>
                {this.state.isAddingSubjects ? <Circles position="static" /> : <>
                    <div className="portfolio-search-result">
                        <div>{this.renderSubjectsGrid(this.state.subjects)}</div>
                        {this.state.notFoundSubjects && <div className="columns is-centered">
                            <a className="link-functional" target="_blank" href={this.getBulkTempFileUrl(this.state.notFoundSubjects)}>
                                {this.getSubjectType() === "companies" && <Translate id="Portfolio.NotFound.Subjects" />}
                                {this.getSubjectType() === "persons" && <Translate id="Portfolio.Invalid.Subjects" />}
                                {this.getSubjectType() === "documents" && <Translate id="Portfolio.NotFound.Subjects" />}
                            </a>
                        </div>}
                        {this.state.subjectsSource === FROM_SEARCH && <div className="columns">
                            <div className="field bb-field" style={{ width: "100%" }}>
                                <div className="control" data-error="false">
                                    <div className="columns" style={{ display: "flex", alignItems: "center", height: "100%" }}>
                                        <div className="column is-2">
                                            <Translate id="Monitoring.Add.Label" />
                                        </div>
                                        <div className="column is-10">
                                            <input onKeyDown={(e) => e.keyCode === 13 && this.addSubjects()} type="text" className="input form-control"
                                                value={this.state.label} onChange={(e) => this.setState({ label: e.target.value })} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                        <div className="modal-inner-buttons portfolio-search-buttons">
                            <button className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                                onClick={() => this.reset()}
                            >
                                <Translate id="Common.Back" />
                            </button>
                            <button onClick={() => this.addSubjects()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} disabled={this.state.selected.length === 0 && this.state.checkOption === CHECK_OPTIONS.none}>
                                <Translate id="Common.Select" />
                            </button>
                        </div>
                    </div>
                </>
                }
            </>
        );
    }

    renderDocumentSearch = () => {
        return (
            <>
                {this.state.documentMessage && <Message type={this.state.documentMessage.type} options={{ renderInnerHtml: true }}
                    message={this.props.translate(this.state.documentMessage.message, this.state.documentMessage.messageData)} />}
                <PropertySkOwnershipDeedSearchForm onSubmitCallback={(values) => this.documentSearchCallback(values)}
                    backClick={() => this.reset()} includeLabel={true} searchBtnTxt={this.props.translate('Common.Add')}
                    regionId={this.state.regionId} districtId={this.state.districtId} municipalityId={this.state.municipalityId} cadastreUnitId={this.state.cadastreUnitId}
                />
            </>
        );
    }

    renderSubjectsGrid = (subjects) => {
        return (
            <div className="columns is-centered" style={{ flexDirection: "column" }}>
                <table className="table table-report-section with-ellipsed-column table-ie-fixed portfolio-add-subjects" style={{ fontSize: "0.8em" }}>
                    <thead>
                        <tr>
                            <th title={this.props.translate("Multiselect.CheckAll")} style={{ width: "12%" }}>
                                <div className="center-content">
                                    <div id={this.state.elementId} onClick={() => this.toggle()} style={{ display: "flex", cursor: "pointer" }}>
                                        <span className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal' })} style={{ margin: "0 .2em", whiteSpace: "nowrap" }}>
                                            <Translate id={`Portfolio.Search.${this.state.checkOption}`} />
                                        </span>
                                        <div className="icon-wrap" style={{ display: "flex" }}>
                                            <AngleDownIcon
                                                style={{ transform: `scaleY(1)`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                                                className='svg-standard-fill' />
                                        </div>
                                    </div>
                                    <Popover onMouseLeave={() => this.hidePopover()} onMouseOver={() => this.keepPopoverVisible()} placement="right" isOpen={this.state.showSelect} toggle={() => this.toggle()} target={this.state.elementId}>
                                        <PopoverBody>
                                            {Object.keys(CHECK_OPTIONS).filter(k => CHECK_OPTIONS[k] !== this.state.checkOption).map(k =>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <span
                                                        onClick={() => this.onOptionClick(CHECK_OPTIONS[k], true)}
                                                        className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal' })}
                                                        style={{ marginLeft: "0.2em" }}>
                                                        {this.props.translate(`Portfolio.Search.${CHECK_OPTIONS[k]}`)}
                                                    </span>
                                                </div>
                                            )}
                                        </PopoverBody>
                                    </Popover>
                                </div>
                            </th>
                            {this.getSubjectType() === "companies" && <th style={{ width: "15%" }}><Translate id="Monitoring.Add.CompanyId" /></th>}
                            {this.getSubjectType() === "persons" && <th style={{ width: "15%" }}><Translate id="Monitoring.Add.DOB" /></th>}
                            {this.getSubjectType() !== "documents" && <th style={{ width: this.state.subjectsSource === FROM_FILE ? "38%" : "48%" }}><Translate id="Common.Title" /></th>}
                            {this.getSubjectType() !== "documents" && <th style={{ width: "15%" }}><Translate id="Search.MarketingSection.Warnings" /></th>}
                            {this.getSubjectType() === "documents" && <>
                                <th style={{ width: "15%" }}><Translate id="PropertySk.Search.OwnershipDeedNo" /></th>
                                <th style={{ width: "15%" }}><Translate id="PropertySk.Search.Region" /></th>
                                <th style={{ width: "15%" }}><Translate id="PropertySk.Search.District" /></th>
                                <th style={{ width: "15%" }}><Translate id="PropertySk.Search.Municipality" /></th>
                                <th style={{ width: "15%" }}><Translate id="PropertySk.Search.CadastreUnit" /></th>
                            </>}
                            {this.state.subjectsSource === FROM_FILE && <th style={{ width: "10%" }}><Translate id="Monitoring.Add.Label" /></th>}
                            <th style={{ width: "10%", textAlign: 'right' }}><Translate id="Portfolio.Search.IsInDb" /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {subjects.map((s, i) => <tr key={this.calcIdx(i)}>
                            <td className="center-content">
                                <BbCheckbox id={`${this.calcIdx(i)}-chk`} customStyle={{ justifyItems: "right" }} value={s.checked}
                                    onChange={(v) => this.onSingleClick(v, i)} useRelativePosition/>
                            </td>
                            {this.getSubjectType() === "companies" && <td>{s.ico}</td>}
                            {this.getSubjectType() === "persons" && <td>{s.birthDateFormated}</td>}
                            {this.getSubjectType() !== "documents" && <>
                                <td className='ellipsed-column'>
                                    <RelationLink entityId={s.entityId} reports={s.reports || {}} entityName={s.name} showOnMobile={true} />
                                </td>
                                <td>{this.renderWarning(s.warnings)}</td>
                            </>}
                            {this.getSubjectType() === "documents" && <>
                                <td>{s.documentNumber}</td>
                                <td>{s.region}</td>
                                <td>{s.district}</td>
                                <td>{s.municipality}</td>
                                <td>{s.cadastralUnit}</td>
                            </>}
                            {this.state.subjectsSource === FROM_FILE && <td>{s.label}</td>}
                            <td className="portfolio-is-in-db"><BbCheckbox id={`${i}-chkDb`} value={s.isRegistered} disabled={true} onChange={() => { }} /></td>
                        </tr>)}
                    </tbody>
                </table>
                {this.renderPaging()}
            </div>
        )
    }

    calcIdx = (i) => {
        return (this.page - 1) * this.pageSize + i;
    }

    renderWarning = (w) => {
        return <div style={{ display: "flex", whiteSpace: "pre-wrap", flexWrap: "wrap" }}>
            {w && w.map((x, i) => <span key={i}>
                <span style={{ whiteSpace: "nowrap" }}>
                    <span className={`r-padded rel-warn rel-warn-status-${x.statusId}`}>{x.shortening}</span>
                </span>
            </span>)}
        </div>
    }

    renderPaging = () => {
        if (!this.page || Math.ceil(this.state.totalCount / this.pageSize) <= 1)
            return <div />;

        return (
            <div className='column is-centered paging-root'>
                <Paging selectedPage={this.page}
                    totalPages={Math.ceil(this.state.totalCount / this.pageSize)}
                    setPage={page => {
                        this.page = page;
                        this.submitQuickSearch(false);
                    }} />
            </div>
        );
    }

    documentSearchCallback = (values) => {
        let params = {
            searchBy: 5,
            cadastreUnitId: parseInt(values.cadastreUnitId),
            ownershipDeedNumber: parseInt(values.ownershipDeedNo)
        }
        this.setState({
            isLoading: true,
            regionId: values.regionId,
            districtId: values.districtId,
            municipalityId: values.municipalityId,
            cadastreUnitId: values.cadastreUnitId
        });
        this.props.propertySkSearch(params, (result) => this.documentSearchSuccess(values, result));
    }

    documentSearchSuccess = (values, result) => {
        this.setState({ isLoading: false });
        if (!isNullOrUndefined(result.data.error) && !isNullOrUndefined(result.data.error.code) && result.data.error.code !== 200) {
            return;
        }
        var document;
        if (result.data.ownershipDocuments.length !== 0) {
            document = {
                label: values.label,
                isRegistered: true,
                cadastreUnitId: parseInt(values.cadastreUnitId),
                ownershipDocumentNumber: result.data.ownershipDocuments[0].ownershipDocumentNumber
            };
        } else {
            document = {
                label: values.label,
                isRegistered: false,
                cadastreUnitId: parseInt(values.cadastreUnitId),
                ownershipDocumentNumber: parseInt(values.ownershipDeedNo)
            };
        }
        this.addDocument(document);
    }

    getPopupTitleTrKey = () => {
        switch (this.state.subjectsSource) {
            case FROM_SEARCH: return this.state.subjects.length > 0 ? "Search.Result" : "Search.Common.SubjectSearch";
            case FROM_FILE: return this.state.subjects.length > 0 ? "Search.Result" : "Marketing.Insert.File";
            default: return "Portfolio.Add.Subject";
        }
    }

    addSubjects = () => {
        this.setState({ isAddingSubjects: true })
        let subjects = [];
        subjects.push(...this.state.selected.map(x => ({
            entityId: x.entityId,
            name: x.name,
            companyId: x.ico,
            label: this.state.subjectsSource === FROM_FILE ? x.label : this.state.label,
            birthDate: x.birthDate,
            rcc: x.rcc,
            ownershipDocumentNumber: x.documentNumber,
            cadastreUnitId: x.cadastreUnitId,
            isRegistered: x.isRegistered
        })));

        apiPost(
            `${getHostApi()}/api/portfolio/${this.getPortfolioId()}/subjects/add`,
            { id: this.getPortfolioId() },
            { subjects, deselected: this.state.deselected, searchInput: this.getSearchModel(), fromFile: this.state.subjectsSource === FROM_FILE, checkOption: this.state.checkOption, label: this.state.label },
            (r) => {
                if (r.data.isSuccess) {
                    this.setState({ isAddingSubjects: false, addError: null });
                    this.props.changeMessage("success", this.props.translate('ConflictOfInterest.ListUpdatedSubjectsAdded').replace('{0}', r.data.value.addedItems));
                    this.props.refresh();
                    this.props.close(false);
                }
                else
                    this.setAddError(r.data.exception, r.data.exceptionData, { isAddingSubjects: false });
            },
            (e) => {
                writeErr(e);
                this.setAddError("Common.Error", null, { isAddingSubjects: false });
            }
        )
    }

    addDocument = (document) => {
        this.setState({ isAddingSubjects: true })
        let documents = [];
        documents.push(document);

        apiPost(
            `${getHostApi()}/api/portfolio/${this.getPortfolioId()}/subjects/add`,
            { id: this.getPortfolioId() },
            { subjects: documents },
            (s) => {
                if (s.data.isSuccess) {
                    this.setState({ isAddingSubjects: false })
                    if (s.data.value === 0)
                        this.setDocumentMessage("error", "Portfolio.Search.DocumentExists");
                    else if (document.isRegistered)
                        this.setDocumentMessage("success", "Portfolio.Search.PortfolioUpdated");
                    else
                        this.setDocumentMessage("warning", "Portfolio.Search.DocumentNotInDb");
                    this.props.refresh();
                } else
                    this.setDocumentMessage("error", s.data.exception, s.data.exceptionData);
            },
            (e) => {
                writeErr(e);
                this.setDocumentMessage("error", "Common.Error", null, { isAddingSubjects: false });
            }
        );
    }

    fileUploaded = (file) => {
        this.setState({ file: file, isLoading: true });
        var type = "";
        if (this.getSubjectType() === "companies")
            type = "company";
        else if (this.getSubjectType() === "persons")
            type = "person";
        else
            type = "document";

        apiPost(`${getHostApi()}/api/portfolio/search/from-file/${type}/${parseInt(this.getListMarketAttribute())}`,
            null,
            { fileName: file.fileName, fileBytes: file.fileBytes, contentType: file.contentType },
            (s) => {
                if (s.data.isSuccess)
                    this.onUploadSuccess(s);
                else
                    this.setExcelError(s.data.exception, type, s.data.exceptionData, { isLoading: false });
            },
            (e) => {
                writeErr(e);
                this.setExcelError("Common.Error", null, { isLoading: false });
            }
        );
    }

    onUploadSuccess = (r) => {
        let subjectType = this.getSubjectType();
        if (r.error)
            this.setExcelError("Report.Common.InvalidData", null, { isLoading: false });
        else {
            var selected = [];
            r.data[subjectType].filter(f => f.checked === true).map((m, i) => selected.push({ ...m, index: i }));
            var subjects = [];
            r.data[subjectType].map((s, i) => subjects.push({ ...s, checked: s.checked === true, index: i }));
            this.setState({
                subjects: subjects, warningMessage: r.data.warningMessage, isLoading: false, notFoundSubjects: r.data.notFound,
                excelError: null, selected: selected, checkOption: CHECK_OPTIONS.onlyInDb
            },
                () => this.onOptionClick(this.state.checkOption, true));
        }
    }

    getSearchModel = () => {
        let model = Object.assign({}, SEARCH_MODEL);
        let isIco = /^\d{8}$/.test(this.state.searchTerm);
        if (isIco)
            model.companyId = isNullOrUndefined(this.state.searchTerm) ? null : this.state.searchTerm.trim()
        else {
            model.name = isNullOrUndefined(this.state.searchTerm) ? null : this.state.searchTerm.trim();
            model.surname = isNullOrUndefined(this.state.searchTermSurname) ? null : this.state.searchTermSurname.trim();
        }
        model.birthDate = this.state.dob;
        model.personalId = isNullOrUndefined(this.state.pin) ? null : this.state.pin.trim();
        return model;
    }

    submitQuickSearch = (resetPaging) => {
        this.setState({ isLoading: true, searchFinished: false });
        if (resetPaging) {
            this.page = 1;
            this.setState({ selected: [] });
        }
        let pt = this.getPortfolioType();
        let model = this.getSearchModel();
        apiPost(`${getHostApi()}/api/portfolio/search/${pt}/subjects/${this.pageSize * (this.page - 1)}/${this.pageSize}`,
            null,
            model,
            (s) => {
                if (s.data.isSuccess)
                    this.onSearchSuccess(s.data, resetPaging);
                else
                    this.setErrorMessage(s.data.exception, s.data.submessages, s.data.exceptionDetails, s.data.exceptionData, { isLoading: false });
            },
            (e) => {
                writeErr(e);
                this.setErrorMessage("Common.Error", null, { isLoading: false });
            }
        );
    }

    getSubjectType = () => {
        let pt = this.getPortfolioType();
        switch (pt) {
            case PORTFOLIO_TYPES.companyCz:
            case PORTFOLIO_TYPES.companySk:
                return "companies";
            case PORTFOLIO_TYPES.personCz:
            case PORTFOLIO_TYPES.personSk:
                return "persons";
            case PORTFOLIO_TYPES.cadastreSk:
                return "documents";
            default: return "";
        }
    }

    onSearchSuccess = (r, resetPaging) => {
        //for subjects returned from quick search, we need to filter data
        let subjectType = this.getSubjectType();
        this.setState({
            isLoading: false,
            searchFinished: true,
            warningMessage: r.warningMessage,
            errorMessage: null,
            subjects: r[subjectType].map((s, i) => ({
                entityId: s.entityId,
                name: s.name,
                address: s.address,
                ico: s.ico,
                checked: this.state.selected.filter(s => s.index === this.calcIdx(i)).length > 0,
                warnings: s.warnings,
                reports: s.reports,
                birthDate: s.birthDate,
                birthDateFormated: s.birthDateFormated,
                rcc: s.rcc,
                isRegistered: s.isRegistered,
                index: (this.page - 1) * this.pageSize + i
            })),
            totalCount: r.total,
        }, () => this.onOptionClick(this.state.checkOption, resetPaging));
    }

    getOptionCondition = (subject, option) => {
        if (isNullOrUndefined(subject) || isNullOrUndefined(option))
            return null;

        switch (option) {
            case CHECK_OPTIONS.onlyInDb:
                return subject.isRegistered === true;
            case CHECK_OPTIONS.unmatched:
                return subject.isRegistered === false;
            case CHECK_OPTIONS.none:
                return false;
            case CHECK_OPTIONS.all:
            default:
                return true;
        }
    }

    onOptionClick = (option, resetPaging) => {
        if (isNullOrUndefined(option))
            return null;

        var selected = [];
        var deselected = [];
        if (!resetPaging) {
            selected = this.state.selected;
            deselected = this.state.deselected;
        }
        if (option !== CHECK_OPTIONS.none && this.state.subjectsSource === FROM_FILE) {
            this.state.subjects.forEach(s => {
                if (this.getOptionCondition(s, option))
                    selected.push(s);
            });
        }

        let copy = [...this.state.subjects];
        copy.forEach(x => { x.checked = this.getOptionCondition(x, option) });
        selected.forEach(s => copy.filter(c => c.index === s.index).forEach(x => x.checked = true));
        deselected.forEach(d => copy.filter(c => c.entityId === d).forEach(x => x.checked = false));
        this.setState({ checkOption: option, subjects: copy, selected: selected, deselected: deselected });
    }

    onSingleClick = (value, idx) => {
        var subjects = this.state.subjects;
        subjects[idx].checked = value;
        var selected = this.state.selected;
        var deselected = this.state.deselected;
        if (value) {
            selected.push(subjects[idx]);
            deselected = deselected.filter(d => { return d !== subjects[idx].entityId });
        }
        else {
            selected = selected.filter(s => { return s.index !== this.calcIdx(idx) });
            deselected.push(subjects[idx].entityId);
        }
        this.setState({ subjects: subjects, selected: selected, deselected: deselected });
    }

    getListMarketAttribute = () => {
        let portfolioType = this.props.formik.values.identification.portfolioType;
        return this.props.domain['monitored-list-types'].requestResult.find(x => x.value === portfolioType.toString()).shortening === "CZ" ? 1 : 2;
    }

    setDocumentMessage = (type, message, messageData = null, additional = {}) => {
        this.setState({ ...additional, documentMessage: { type: type, message: message, messageData: this.getValueOrUndefined(messageData) } });
    }

    setExcelError = (exception, searchType, exceptionData = null, additional = {}) => {
        this.setState({ ...additional, excelSearchType: searchType, excelError: { exception: exception, exceptionData: this.getValueOrUndefined(exceptionData) } });
    }

    setAddError = (exception, exceptionData = null, additional = {}) => {
        this.setState({ ...additional, addError: { exception: exception, exceptionData: this.getValueOrUndefined(exceptionData) } });
    }

    setErrorMessage = (exception, submessages, exceptionDetails = null, exceptionData = null, additional = {}) => {
        this.setState({
            ...additional, warningMessage: null,
            errorMessage: { exception: exception, submessages: submessages, exceptionDetails: exceptionDetails, exceptionData: this.getValueOrUndefined(exceptionData) }
        });
    }

    reset = (source = null) => this.setState({ ...DEFAULT_STATE, subjectsSource: source });
    getPortfolioType = () => this.props.formik.values.identification.portfolioType;
    initAllStatus = () => this.getSubjectType() === "persons" ? 0 : 2;
    getPortfolioId = () => window.location.pathname.match(/\d+/)[0];
    canSearch = (model) => Object.keys(model).some(k => !isNullOrUndefined(model[k]) && ((typeof model[k] === "string" && model[k].length > 0) || model[k] instanceof Date));
    getValueOrUndefined = v => isNullOrUndefined(v) ? undefined : v;

    toggle() {
        var isVisible = this.state.showSelect;
        this.setState({ showSelect: !this.state.showSelect });
        if (!isVisible) {
            this.autoHidePopover();
        }
    }

    autoHidePopover = () => {
        this._noConflictPopover2 = window.setTimeout(() => this.setState({ showSelect: false }), 1500);
    }

    keepPopoverVisible = () => {
        if (this._noConflictPopover2 !== undefined && this._noConflictPopover2 !== null) {
            window.clearTimeout(this._noConflictPopover2);
        }

    }

    hidePopover = () => {
        if (this._noConflictPopover2 !== undefined && this._noConflictPopover2 !== null) {
            window.clearTimeout(this._noConflictPopover2);
            this._noConflictPopover2 = undefined;
        }

        window.setTimeout(() => this.toggle(), 250);
    }

    getBulkTemplateUrl(portfolioType, languageCode) {
        const portType = Object.keys(PORTFOLIO_TYPES).find(k => PORTFOLIO_TYPES[k] === portfolioType);
        const langCode = isValidLanguage(languageCode) ? languageCode : "sk-SK";
        return isNullOrUndefined(portType) ? "#" : `${getHostApi()}/api/portfolio/download/${PORTFOLIO_TYPES[portType]}/${langCode}`;
    }

    getBulkTempFileUrl(file) {
        return !isGuid(file) ? "#" : `${getHostUrl()}/files/portfolio/bulk/${file}`;
    }
}

export default withRouter(withLocalize(connect(
    state => { return { domain: state.domain, user: state.userContext, search: { ...state.search.propertySk } } },
    dispatch => bindActionCreators({ ...domainActions, ...searchActions }, dispatch),
)(SearchSubjectPopup)));

